/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import './polyfills';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';
import { defineCustomElements as pwaElements } from '@ionic/pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}
// Initialize the SQLite plugin for web
jeepSqlite(window);

// Initialize the PWA elements
pwaElements(window);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
